export default __webpack_public_path__ + "static/products-bg-md-a615e45ea488d54fd7e6531fba6175de.png";